import React, { Component } from 'react';
import { db } from '../../firebase';
import moment from 'moment'
import request from 'request';

//import lots from "../../data/lot.json";
import signups from "../../data/signup.json";

var MY_SLACK_WEBHOOK_URL = 'https://hooks.slack.com/services/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';
var slack = require('slack-notify')(MY_SLACK_WEBHOOK_URL);
slack.onError = function (err) {
  console.log('API error:', err);
};

export default class CastLogin extends Component {
  constructor (props) {
    super(props);

    this.state = {
      pre_reservation_id: "",
      date_id: 0,
      date: "",
      cast_id: "",
      reservation: {
        casts:[
          ["-McrXJfCaDE-TKZdV51W", "-McqUNzFLaGcJTF931NT"],
          ["-McrXJfCaDE-TKZdV51W", "-McqUNzFLaGcJTF931NT"],
        ],
        dates: ["1628051400000", "1628053200000"],
        user_id: "-MgENmXbqRmPLTZ309lT",
        lot: 0,
        menu: "リビング・ダイニング",
        menu_etc: "",
        agreement: "1"
      },
      cast: {},
      user: {
        family_name: "",
        address: "",
        apartment: "",
        age: 1,
        sex: 0,
        family: 0,
        cleaning_frequency: 0,
        children: 1,
        pet: 0
      },
      agreement: 0,
      errors: {}
    };
  }

  componentWillMount () {
    var scope = this
    var reservation_id = this.props.match.params.reservation_id
    var user_id = this.props.match.params.user_id
    var cast_id = this.props.match.params.cast_id
    scope.setState({ cast_id: cast_id })


    console.log(reservation_id, user_id, cast_id)

    db.ref('casts/' + cast_id).on('value', snapshot => {
      var cast = snapshot.val()
      //console.log(casts)
      scope.setState({ cast: cast })
    });

    db.ref('pre_reservations/' + user_id + "/" + reservation_id).on('value', snapshot => {
      var reservation = snapshot.val()
      console.log(reservation)

      //scope.setState({ reservation: reservation, agreement:reservation.agreement })

      db.ref('lp/users/' + reservation.user_id).on('value', snapshot => {
        var user = snapshot.val()
        console.log(user)
        scope.setState({ user: user })
      });
    });
  }

  validation (e) {
    //console.log(this.state.reservation.report)
    var errors = {}

    this.setState({errors: errors}, () => {
      if (Object.keys(this.state.errors).length === 0) {
        this.send()
      }
    });
  }

  send() {

    var reservation_id = this.props.match.params.reservation_id
    var user_id = this.props.match.params.user_id
    var cast_id = this.props.match.params.cast_id

    var data = this.state.reservation
    data.agreement = this.state.agreement

    var agree = false
    if (this.state.agreement === "1" || this.state.agreement === "2" || this.state.agreement === "3") {
      agree = true
    }
    if (agree) {
      data.cast_id = cast_id
      data.attribute = "1"
    }

    var scope = this
    db.ref('pre_reservations/' + user_id + '/' + reservation_id + '/').update(data).then(function() {
      if (agree) {
        // ユーザー側にメール通知
        var sendgrid_url = process.env.REACT_APP_FUNCTIONS_URL + "/email"

        var ids = [user_id]
        var emails = [scope.state.user.email]
        var title = "ご予約が確定しました。／三菱地所の家事代行30min."
        //menus.find(m => m.id === data.menu).title
        var text = scope.state.user.family_name + "さま\n初めまして。三菱地所の家事代行 30min.事務局でございます。\nこのたびは、お試しキャンペーンにお申込みいただき、ありがとうございます。\n\nお申し込みが確定いたしました。\n\nよろしくお願いいたします。\n----------------------------------------\n三菱地所の家事代行30min. 事務局\nthirty-min@mec.co.jp"
        //console.log(emails)

        var options3 = {
          uri: sendgrid_url,
          headers: {
            "Content-type": "application/json",
          },
          json: {
            "ids": ids,
            "emails": emails,
            "subject": title,
            "body": text
          }
        }

        request.post(options3, function(error, response, body){
          scope.props.history.push("/cast_done");
        });
      } else {
        scope.props.history.push("/cast_done");
      }
    }).catch(function (error) {
      // An error happened.
      scope.setState({errors: {"server": "サーバーとの通信に失敗しました。大変お手数ですが、数分後に再度やり直してください"}})
    });
  }

  render () {
    const reservation_list = <div>
          <p>氏名：{this.state.user.family_name}様</p>
          <p>住所：{this.state.user.address} {this.state.user.apartment}</p>
          <p>年代：{signups["age"][this.state.user.age]}</p>
          <p>性別：{signups["sex"][this.state.user.sex]}</p>
          <p>家族構成：{signups["family"][this.state.user.family]}</p>
          <p>掃除頻度：{signups["cleaning_frequency"][this.state.user.cleaning_frequency]}</p>
          <p>子供：{signups["children"][this.state.user.children]}</p>
          <p>ペット：{signups["pet"][this.state.user.pet]}</p>
          <p>メニュー：{this.state.reservation.menu}</p>
          <p>時間数：{this.state.reservation.lot}分</p>
          <br />
        </div>

    moment.locale('ja', {weekdays: ["日", "月", "火", "水", "木", "金", "土"]});
    const dates = this.state.reservation.dates.map((date, i) => {
      return <p>第{i + 1}希望：{moment(parseInt(date, 10)).format("YYYY年MM月DD日(dddd) HH:mm")}〜{moment(parseInt(date, 10)).add(this.state.reservation.lot, "m").format("HH:mm")}</p>
    })

    const selects = this.state.reservation.dates.map((date, i) => {
      return <option value={i + 1}>第{i + 1}希望で承認</option>
    })

    const agreement_button = () => {
      console.log(this.state.reservation)
      let ret
      if (this.state.reservation.agreement !== "1" && this.state.reservation.agreement !== "2" && this.state.reservation.agreement !== "3") {
        ret = <>
        <p className="bold">日程一覧</p>
          {dates}
          <select value={this.state.agreement} onChange={e => this.setState({agreement: e.target.value})}>
            <option value="0">検討中</option>
            {selects}
            <option value="4">拒否</option>
          </select>

          <div className="buttons">
            <button onClick={this.validation.bind(this)}>確定</button>
          </div>
          <p className="error-message">{this.state.errors.server}</p>
          </>
      } else {
        ret = <p>予約確定済み</p>
      }
      return ret
    }

    return (
    <div className="sp home">
      <h2>承認</h2>
      <div className="content-wrapper">
        <div className="contents">

          <p>あなたに依頼が届きました。内容に問題がなければ承認ボタンを押してください。</p>
          <br />

          <p className="bold">依頼詳細</p>
          {reservation_list}
          <br />

          {agreement_button()}

          <br />
          <a href={"/cast_agreements/" + this.state.cast_id}>一覧へ</a>
        </div>
      </div>
    </div>
    );
  }
}